import React from "react";
import { FiSettings, FiLogOut } from "react-icons/fi";
import { BiBell } from "react-icons/bi";
import { getLocalStorageItem } from "../Utils/Helper";
import { ColorModeButton } from "./ui/color-mode";
import { useAppTheme } from "../Hooks/useAppTheme";

// Helper function to capitalize first letter of each word
const capitalizeName = (name) => {
  if (!name) return "";
  return name
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const PageHeader = ({ title, onLogoutClick }) => {
  const theme = useAppTheme();
  const userDataLocalStorage = getLocalStorageItem("userData");
  
  // Get user name (trying different possible fields)
  const rawUserName = userDataLocalStorage?.name || 
                 userDataLocalStorage?.fullName || 
                 userDataLocalStorage?.firstName || 
                 userDataLocalStorage?.username || 
                 "User";
  
  // Capitalize the user name
  const userName = capitalizeName(rawUserName);
  
  // Get account number
  const accountNo = userDataLocalStorage?.accountno || 0;
  
  return (
    <div className="px-6 py-3 rounded-xl mb-6 shadow-sm flex items-center justify-between" style={{ backgroundColor: theme.bgCard, color: theme.textPrimary }}>
      <h1 className="text-lg font-semibold">{title}</h1>
      <div className="flex items-center gap-14 text-sm" style={{ color: theme.textSecondary }}>
        <span>Welcome! {userName}</span>
        {accountNo && accountNo !== 0 && (
          <span className="px-2 py-1 rounded" style={{ backgroundColor: theme.brandPrimary, color: theme.iconText }}>
            Account No.: {accountNo}
          </span>
        )}
      </div>
      <div className="flex items-center gap-4 text-xl" style={{ color: theme.brandPrimary }}>
        <ColorModeButton />
        <button title="Settings">
          <FiSettings />
        </button>
        <button title="Notifications">
          <BiBell />
        </button>
        <button onClick={onLogoutClick} title="Logout">
          <FiLogOut />
        </button>
      </div>
    </div>
  );
};


